import React, { useEffect, useState } from "react";
import InventoryList from "./InventoryList";
import AddItemModal from "./AddItemModal";
import UpdateStockModal from "./UpdateStockModal";
import {
  getInventory,
  addInventoryItem,
  updateStock,
  deleteInventoryItem,
} from "./inventoryApi";
import "./inventory-theme.css";
import BackButton from "../BackButton";

export default function InventoryPage() {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showStockModal, setShowStockModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const loadInventory = async () => {
    try {
      const res = await getInventory();
      setInventory(res.data);
    } catch (e) {
      setInventory([
        {
          id: 1,
          name: "Towel",
          category: "Produce",
          quantity: 12.5,
          unit: "kg",
          minThreshold: 5,
          expiryDate: "2025-12-01",
        },
        {
          id: 2,
          name: "Milk",
          category: "Dairy",
          quantity: 2,
          unit: "kg",
          minThreshold: 5,
          expiryDate: "2025-12-03",
        },
        {
          id: 3,
          name: "Toothbrush",
          category: "Produce",
          quantity: 10,
          unit: "pcs",
          minThreshold: 1,
          expiryDate: "",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadInventory();
  }, []);

  const handleAddItem = async (data) => {
    try {
      await addInventoryItem(data);
      loadInventory();
    } catch {
      setInventory([...inventory, data]);
    }
  };

  const handleStockUpdate = async (id, mode, delta, reason, expiry) => {
    const payload = {
      adjustType: mode,
      qty: Number(delta),
      reason,
      expiry,
    };

    try {
      await updateStock(id, payload);
      loadInventory();
    } catch {
      setInventory(
        inventory.map((i) =>
          i.id === id
            ? {
                ...i,
                quantity:
                  mode === "add"
                    ? i.quantity + Number(delta)
                    : i.quantity - Number(delta),
              }
            : i
        )
      );
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteInventoryItem(id);
      loadInventory();
    } catch {
      setInventory(inventory.filter((i) => i.id !== id));
    }
  };

  const openStockModal = (item) => {
    setSelectedItem(item);
    setShowStockModal(true);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <BackButton />
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Inventory List</h3>
            <div className="col-auto d-flex w-sm-100">
              <button
                type="button"
                className="btn btn-dark"
                onClick={() => setShowAddModal(true)}
              >
                Add Item
              </button>
              {/* <button
                type="button"
                className="btn btn-dark"
                data-bs-toggle="modal"
                data-bs-target="#add-room-type"
                aria-controls="add-room"
              >
                Add Room
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <InventoryList
                items={inventory}
                onEdit={(item) => console.log("edit:", item)}
                onDelete={handleDelete}
                onStockClick={openStockModal}
                loading={loading}
              />
            </div>
          </div>
        </div>
      </>
      {showAddModal && (
        <AddItemModal
          isOpen={showAddModal}
          onClose={() => setShowAddModal(false)}
          onAdd={handleAddItem}
        />
      )}
      {showStockModal && (
        <UpdateStockModal
          isOpen={showStockModal}
          item={selectedItem}
          onClose={() => setShowStockModal(false)}
          onUpdate={handleStockUpdate}
        />
      )}
    </div>
  );
}
